import { ShopCommonLayout } from "../../layouts/ShopCommonLayout";
import React, { useEffect, useState } from "react";
import TextInput from "../../components/UI/TextInput";
import CheckBox from "../../components/UI/CheckBox";
import { Button } from "../../components/UI/Button";
import { type FieldErrors, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authUseCase } from "../../../di/container";
import { z } from "zod";

const CompanySignup = () => {
  interface CompanySignupForm {
    name: string;
    companyName: string;
    businessCertificate: FileList;
    password: string;
    passwordConfirm: string;
    isAgree: boolean;
    isAgreePrivacy: boolean;
    isCompanyNoticeReviewed: boolean;
    isSubscribe: boolean;
  }
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<CompanySignupForm>({
    shouldUnregister: false,
  });

  const onSubmit = (data: CompanySignupForm) => {
    // todo: 회원가입 API 호출
  };
  const onError = (errors: FieldErrors<FormData>) => {
    const keys = Object.keys(errors) as (keyof FormData)[];

    for (const key of keys) {
      const error = errors[key];
      if (error) {
        console.error(
          error.message ? String(error.message) : "입력값을 확인해주세요.",
        );
        break;
      }
    }
  };

  const businessCertificateWatch = watch("businessCertificate");

  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);

  const { isAgree, isAgreePrivacy, isCompanyNoticeReviewed, isSubscribe } =
    watch();

  useEffect(() => {
    if (
      isCheckboxEnabled &&
      (!isAgree || !isAgreePrivacy || !isCompanyNoticeReviewed || !isSubscribe)
    ) {
      setIsCheckboxEnabled(false);
    }

    if (isAgree && isAgreePrivacy && isCompanyNoticeReviewed && isSubscribe) {
      setIsCheckboxEnabled(true);
    }
  }, [
    isAgree,
    isAgreePrivacy,
    isCheckboxEnabled,
    isCompanyNoticeReviewed,
    isSubscribe,
  ]);
  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div>
        <div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">이름(대표자명)</div>
            <TextInput
              placeholder="이름(대표자명)을 입력해 주세요."
              error={{
                message: errors.name?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("name", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">업체명</div>
            <TextInput
              placeholder="주문자 실명을 입력해 주세요."
              error={{
                message: errors.companyName?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("companyName", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">
              사업자등록증/고유번호증
            </div>
            <input
              type="file"
              className="hidden"
              accept=".png,.jpg,.jpeg,.pdf"
              {...register("businessCertificate", {
                required: {
                  value: true,
                  message: "필수 항목이에요.",
                },
              })}
            />

            <label>
              <div className="w-full flex flex-row gap-[0.75rem]">
                <div
                  className={`
                     ${errors.businessCertificate?.message ? "outline-[#F24A4A]" : ""}
                     relative p-3 w-full h-[2.875rem] bg-[#F8F8F8] outline outline-1 outline-[#D9D9D9] rounded-[0.5rem]`}
                >
                  {businessCertificateWatch &&
                  businessCertificateWatch.length > 0 ? (
                    <div>{businessCertificateWatch[0].name}</div>
                  ) : (
                    <>{businessCertificateWatch}</>
                  )}
                  {errors.businessCertificate?.message ? (
                    <div className="flex items-center absolute top-0 bottom-0 right-[0.7188rem]">
                      <img
                        className="w-[1.2213rem]"
                        alt="alert icon"
                        src="/assets/icons/alerticon.svg"
                      />
                    </div>
                  ) : null}
                </div>
                <input
                  type="file"
                  className="hidden"
                  accept=".png,.jpg,.jpeg,.pdf"
                  {...register("businessCertificate", {
                    required: {
                      value: true,
                      message: "필수 항목이에요.",
                    },
                  })}
                />
                <div className="whitespace-nowrap bg-white w-[20%] flex justify-center items-center px-[0.75rem] py-[0.5rem] rounded-[8px] border border-[#D9D9D9] hover:bg-[#e6e6e6] transition-all">
                  파일 선택
                </div>
              </div>
            </label>
            {errors.businessCertificate?.message ? (
              <div className="text-[12px] mt-[0.25rem] text-[#F24A4A]">
                {errors.businessCertificate?.message}
              </div>
            ) : null}
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">비밀번호</div>
            <TextInput
              placeholder="영문 숫자 특수문자 조합 8-16자리"
              type="password"
              error={{
                message: errors.password?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("password", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
                pattern: {
                  value: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/,
                  message: "영문, 숫자, 특수문자만 입력 가능합니다",
                },
                minLength: {
                  value: 8,
                  message: "비밀번호는 8자 이상이어야 합니다",
                },
                maxLength: {
                  value: 16,
                  message: "비밀번호는 16자 이하여야 합니다",
                },
                validate: {
                  hasLetter: (value) =>
                    /[a-zA-Z]/.test(value) || "영문자를 포함해야 합니다",
                  hasNumber: (value) =>
                    /[0-9]/.test(value) || "숫자를 포함해야 합니다",
                  hasSpecial: (value) =>
                    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(value) ||
                    "특수문자를 포함해야 합니다",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">비밀번호 확인</div>
            <TextInput
              placeholder="비밀번호를 다시 입력해 주세요."
              type="password"
              error={{
                message: errors.passwordConfirm?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("passwordConfirm", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
                pattern: {
                  value: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/,
                  message: "영문, 숫자, 특수문자만 입력 가능합니다",
                },
                validate: (value) =>
                  value === watch("password") || "비밀번호가 일치하지 않습니다",
              })}
            />
          </div>
        </div>

        <div>
          <div
            role="button"
            onClick={() => {
              if (
                isAgree &&
                isAgreePrivacy &&
                isCompanyNoticeReviewed &&
                isSubscribe
              ) {
                setValue("isAgree", false);
                setValue("isAgreePrivacy", false);
                setValue("isCompanyNoticeReviewed", false);
                setValue("isSubscribe", false);
                setIsCheckboxEnabled(false);
              } else {
                setValue("isAgree", true);
                setValue("isAgreePrivacy", true);
                setValue("isCompanyNoticeReviewed", true);
                setValue("isSubscribe", true);
                setIsCheckboxEnabled(true);
              }
            }}
            className="text-start flex flex-row gap-[0.375rem] mb-[0.5rem]"
          >
            <CheckBox isEnabled={isCheckboxEnabled} /> <div>전체 선택</div>
          </div>

          <div className="text-start flex flex-col gap-[0.5rem] mb-[1.25rem]">
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isAgree", !watch("isAgree"));
              }}
            >
              <img
                src={
                  watch("isAgree")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(필수) 서비스 이용약간 동의</div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isAgreePrivacy", !watch("isAgreePrivacy"));
              }}
            >
              <img
                src={
                  watch("isAgreePrivacy")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(필수) 개인정보 수집 및 이용 동의</div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue(
                  "isCompanyNoticeReviewed",
                  !watch("isCompanyNoticeReviewed"),
                );
              }}
            >
              <img
                src={
                  watch("isCompanyNoticeReviewed")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(필수) 기업회원 가입 시 유의사항</div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isSubscribe", !watch("isSubscribe"));
              }}
            >
              <img
                src={
                  watch("isSubscribe")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(선택) 이벤트, 할인, 신제품 소식 제일 먼저 받기</div>
            </div>
          </div>

          <Button className="w-full h-[3rem]">회원 가입하기</Button>

          <div className="mb-[103px]"></div>
        </div>
      </div>
    </form>
  );
};
const GeneralSignup = () => {
  interface GeneralSignupForm {
    email: string;
    name: string;
    password: string;
    passwordConfirm: string;
    isAgree: boolean;
    isAgreePrivacy: boolean;
    isOver14: boolean;
    isSubscribe: boolean;
  }
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<GeneralSignupForm>({
    shouldUnregister: false,
  });
  const onSubmit = (data: GeneralSignupForm) => {
    // todo: 쇼핑몰 업체 아이디 확인하는 기능 추가

    return authUseCase.signup({
      email: data.email,
      password: data.password,
      name: data.name,
      companyId: undefined, // todo: 쇼핑몰 업체 아이디 확인하는 기능 추가
      termsOfServiceAgreed: data.isAgree,
      privacyPolicyAgreed: data.isAgreePrivacy,
      over14YearsOld: data.isOver14,
      promotionNewsSubscribed: data.isSubscribe,
    });
  };

  const onError = (errors: FieldErrors<FormData>) => {
    const keys = Object.keys(errors) as (keyof FormData)[];

    for (const key of keys) {
      const error = errors[key];
      if (error) {
        console.error(
          error.message ? String(error.message) : "입력값을 확인해주세요.",
        );
        break;
      }
    }
  };

  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);

  const { isAgree, isAgreePrivacy, isOver14, isSubscribe } = watch();

  useEffect(() => {
    if (
      isCheckboxEnabled &&
      (!isAgree || !isAgreePrivacy || !isOver14 || !isSubscribe)
    ) {
      setIsCheckboxEnabled(false);
    }

    if (isAgree && isAgreePrivacy && isOver14 && isSubscribe) {
      setIsCheckboxEnabled(true);
    }
  }, [isAgree, isAgreePrivacy, isCheckboxEnabled, isOver14, isSubscribe]);

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div>
        <div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">이메일</div>
            <TextInput
              placeholder="이메일을 입력해 주세요."
              error={{
                message: errors.email?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("email", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">이름/업체명</div>
            <TextInput
              placeholder="주문자 실명을 입력해 주세요."
              error={{
                message: errors.name?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("name", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">비밀번호</div>
            <TextInput
              placeholder="영문 숫자 특수문자 조합 8-16자리"
              type="password"
              error={{
                message: errors.password?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("password", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
                pattern: {
                  value: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/,
                  message: "영문, 숫자, 특수문자만 입력 가능합니다",
                },
                minLength: {
                  value: 8,
                  message: "비밀번호는 8자 이상이어야 합니다",
                },
                maxLength: {
                  value: 16,
                  message: "비밀번호는 16자 이하여야 합니다",
                },
                validate: {
                  hasLetter: (value) =>
                    /[a-zA-Z]/.test(value) || "영문자를 포함해야 합니다",
                  hasNumber: (value) =>
                    /[0-9]/.test(value) || "숫자를 포함해야 합니다",
                  hasSpecial: (value) =>
                    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(value) ||
                    "특수문자를 포함해야 합니다",
                },
              })}
            />
          </div>
          <div className="text-start mb-[16px]">
            <div className="text-start mb-[0.75rem]">비밀번호 확인</div>
            <TextInput
              placeholder="비밀번호를 다시 입력해 주세요."
              type="password"
              error={{
                message: errors.passwordConfirm?.message || "",
                isIconVisible: true,
                isMessageVisible: true,
              }}
              {...register("passwordConfirm", {
                required: {
                  value: true,
                  message: "필수 항목이에요",
                },
                pattern: {
                  value: /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]+$/,
                  message: "영문, 숫자, 특수문자만 입력 가능합니다",
                },
                validate: (value) =>
                  value === watch("password") || "비밀번호가 일치하지 않습니다",
              })}
            />
          </div>
        </div>

        <div>
          <div
            onClick={() => {
              if (isAgree && isAgreePrivacy && isOver14 && isSubscribe) {
                setValue("isAgree", false);
                setValue("isAgreePrivacy", false);
                setValue("isOver14", false);
                setValue("isSubscribe", false);
                setIsCheckboxEnabled(false);
              } else {
                setValue("isAgree", true);
                setValue("isAgreePrivacy", true);
                setValue("isOver14", true);
                setValue("isSubscribe", true);
                setIsCheckboxEnabled(true);
              }
            }}
            className="text-start flex flex-row gap-[0.375rem] mb-[0.5rem]"
          >
            <CheckBox isEnabled={isCheckboxEnabled} /> <div>전체 선택</div>
          </div>

          <div className="text-start flex flex-col gap-[0.5rem] mb-[1.25rem]">
            <div>
              <div
                className="flex flex-row items-center"
                role="button"
                onClick={() => {
                  setValue("isAgree", !watch("isAgree"));
                }}
              >
                <img
                  src={
                    watch("isAgree")
                      ? "/assets/icons/checkbox-checked.svg"
                      : "/assets/icons/checkbox-unchecked.svg"
                  }
                  alt="checkbox"
                  className="w-6 h-6"
                />
                <div>(필수) 서비스 이용약간 동의</div>
              </div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isAgreePrivacy", !watch("isAgreePrivacy"));
              }}
            >
              <img
                src={
                  watch("isAgreePrivacy")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(필수) 개인정보 수집 및 이용 동의</div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isOver14", !watch("isOver14"));
              }}
            >
              <img
                src={
                  watch("isOver14")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(필수) 만 14세 이상입니다</div>
            </div>
            <div
              className="flex flex-row items-center"
              role="button"
              onClick={() => {
                setValue("isSubscribe", !watch("isSubscribe"));
              }}
            >
              <img
                src={
                  watch("isSubscribe")
                    ? "/assets/icons/checkbox-checked.svg"
                    : "/assets/icons/checkbox-unchecked.svg"
                }
                alt="checkbox"
                className="w-6 h-6"
              />
              <div>(선택) 이벤트, 할인, 신제품 소식 제일 먼저 받기</div>
            </div>
          </div>

          <Button className="w-full h-[3rem]">회원 가입하기</Button>

          <div className="mb-[103px]"></div>
        </div>
      </div>
    </form>
  );
};

const ShopSignup = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const formType = searchParams.get("formType") || "general";

  const [registerType, setRegisterType] = React.useState<"general" | "company">(
    "general",
  );

  useEffect(() => {
    if (formType === "general" || !formType) {
      setRegisterType("general");
    } else if (formType === "company") {
      setRegisterType("company");
    }
  }, [formType]);

  return (
    <ShopCommonLayout showNavBar={false}>
      <>
        <div
          className="py-[12px] flex justify-center items-center  /
      bg-white w-full"
        >
          <div className="max-w-[560px] text-[14px] mx-10 w-full flex flex-col">
            <div className="text-[1.875rem] font-bold py-[3.125rem]">LOGO</div>

            <div className="mb-[2.25rem] text-[1.5rem] text-start">
              <h3>
                회원가입 하고
                <br />
                <span className="font-semibold">서비스를 이용하세요.</span>
              </h3>
            </div>

            <div className="flex flex-row justify-start gap-[1.75rem] text-[1rem]">
              <div className="h-[2.25rem]">
                <div
                  role="button"
                  onClick={() => {
                    navigate("/shop/signup");
                  }}
                  className="font-bold"
                >
                  일반회원
                </div>
                {registerType === "general" ? (
                  <div className="h-[0.25rem] bg-[#4285F4] mt-[0.5rem]"></div>
                ) : null}
              </div>
              <div className="h-[2.25rem]">
                <div
                  role="button"
                  onClick={() => {
                    navigate("/shop/signup?formType=company");
                  }}
                  className="font-bold"
                >
                  기업회원
                </div>
                {registerType === "company" ? (
                  <div className="h-[0.25rem] bg-[#4285F4] mt-[0.5rem]"></div>
                ) : null}
              </div>
            </div>
            <div className="mb-[16px]">
              <div className="outline outline-1 outline-[#D9D9D9]"></div>
            </div>
            {registerType === "general" ? <GeneralSignup /> : null}
            {registerType === "company" ? <CompanySignup /> : null}
          </div>
        </div>
      </>
    </ShopCommonLayout>
  );
};

export default ShopSignup;
